var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppHeader'),_c('div',{staticClass:"mt-5 text-center font-weight-bold",attrs:{"id":"main"}},[_c('p',[_vm._v("現在ホームページのメンテナンス中です。")]),_c('p',[_vm._v("今しばらくお待ちください。")])]),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }